module.exports = __webpack_public_path__ + "media/images/top_trial_online_rec-b2db78e78a79522680f484f44f31acd1.png";